<script setup lang="ts">
import type GiftTemplate from '@consumer/types/GiftTemplate'
import type { PlaceDetail } from '@consumer/types/serializers'

import mpGeneralPlaceImage from '@consumer/assets/images/mp-general-place.png'

withDefaults(defineProps<{
  gift: GiftTemplate
  place: PlaceDetail
  index: number
  total: number
}>(), {  })

const DESCRIPTIONS: {
  [key: string]: {
    description: string
    categories: string[]
  }
} = {
  'Any movie theater': {
    description: `Experience film magic at any cinema you like. Enjoy unique screenings,
                 craft drinks, and tasty eats. A movie night like no other!`,
    categories: ['Bars', 'Cinema', 'Dinner Theater'],
  },
}

const placeDescription = computed(() => (
  __props.place.name && DESCRIPTIONS[__props.place.name]?.description
))

const placeCategories = computed(() => (
  __props.place.name && DESCRIPTIONS[__props.place.name]?.categories
))
</script>

<template>
  <div class="bg-white">
    <div class="p-6 space-y-5">
      <div class="flex justify-between">
        <div class="font-semibold">

          {{ place.name }}
        </div>
        <div class="text-sm text-grey-700 font-semibold">{{ index }} of {{ total }}</div>
      </div>

      <div class="mt-6 space-y-4 text-sm">
        <p>
          {{ placeDescription }}
        </p>

        <div class="flex gap-2">
          <div
            v-for="category in placeCategories"
            :key="category"
            class="text-sm text-grey-500 font-semibold bg-grey-300 p-2 rounded-md"
          >
            {{ category }}
          </div>
        </div>

        <img :src="mpGeneralPlaceImage" alt="General place" class="w-full rounded-lg">
      </div>

    </div>
  </div>
</template>
